<div class="min-h-screen flex flex-col bg-base-100">
  <app-navbar [logoClickable]="false">
    <li class="relative !p-0 h-[52px] overflow-hidden cursor-pointer group">
      <div class="p-4 absolute inset-0 bg-menu-bg text-menu-text group-hover:text-base-100 group-hover:bg-[--bc] flex items-center gap-4">
        <span class="material-icons">language</span>
        <span class="inter-400 text-[1.125rem]">{{ selectedLanguage().name }}</span>
      </div>
      <app-language-dropdown />
    </li>
  </app-navbar>

  <main #pageScroller class="flex-1 min-h-0 overflow-auto pt-0 px-4 sm:px-6 bg-base-100 flex flex-col items-center pb-0">
    <div class="w-[95%] max-w-[1800px] mt-[30px] mb-[30px] bg-neutral relative flex flex-col justify-between gap-8 rounded-[10px] pt-[33px] pb-[33px] px-[25px] min-h-[calc(100vh-200px)]">
      <!-- Question Content -->
      <div class="flex-1 min-h-0">
        @if (question(); as question) {
          <app-question
            [question]="question"
            (autoAdvanceSingleChoice)="handleAutoAdvanceSingleChoice()"
          />
        }
      </div>

      <!-- Navigation and Progress Bar -->
      @if (question(); as question) {
        <div class="relative flex flex-col items-center p-4 bg-transparent mt-auto">
          <div class="flex flex-wrap justify-center gap-6">
            <button
              (click)="goToPreviousQuestion()"
              [disabled]="loading()"
              matRipple
              class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[1.125rem] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
            >
              Back
            </button>

            <button
              (click)="goToNextQuestion()"
              [disabled]="!questionComponent?.canMoveToNextQuestion || loading()"
              matRipple
              class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[1.125rem] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
            >
              Next
            </button>
          </div>

          <div class="w-full max-w-2xl mt-8 px-2 sm:px-6">
            <div class="w-full rounded-full h-3 relative overflow-hidden" style="background: linear-gradient(90deg,#F3F2F3,#EBEAEB);">
              <div
                class="absolute left-0 top-0 h-full rounded-full transition-all duration-500 ease-in-out"
                [style.width]="((question.progress ?? 0) * 100) + '%'"
                style="background: linear-gradient(90deg,#764FD4,#392BCC);"
              ></div>
            </div>
          </div>
        </div>
      }
    </div>
  </main>
</div>
